(function () {
  function getPrice(productInfo) {
    var saleEl    = productInfo.querySelector('.price__sale .price-item--sale');
    var regularEl = productInfo.querySelector('.price__regular .price-item--regular');
    var compareEl = productInfo.querySelector('.price__sale .price-item--regular');
    return {
      current: saleEl ? saleEl.textContent.trim() : (regularEl ? regularEl.textContent.trim() : ''),
      compare: compareEl ? compareEl.textContent.trim() : ''
    };
  }

  function injectStars(productInfo) {
    var titleEl = productInfo.querySelector('.product__title');
    if (!titleEl) return;

    var stars = document.createElement('div');
    stars.className = 'tj-stars';
    stars.innerHTML =
      '<span class="tj-stars__icons">★★★★★</span>' +
      '<span class="tj-stars__score">4.8</span>' +
      '<span class="tj-stars__divider">·</span>' +
      '<span class="tj-stars__count">52 reviews</span>';

    titleEl.parentNode.insertBefore(stars, titleEl);
  }

  function init() {
    var productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    // Star rating above title
    injectStars(productInfo);

    var prices = getPrice(productInfo);

    // Read label from theme-configurable element
    var configEl = document.getElementById('tj-product-config');
    var label = (configEl && configEl.dataset.label) ? configEl.dataset.label : 'TheraJaw';

    // Hide native quantity selector
    var nativeWrap = productInfo.querySelector('.product-form__quantity');
    if (nativeWrap) nativeWrap.style.display = 'none';

    // Build summary row
    var row = document.createElement('div');
    row.className = 'tj-qty';

    var badgeHTML = '';
    if (prices.compare && prices.current) {
      var parsePrice = function (s) { return parseFloat(s.replace(/[^0-9.]/g, '')); };
      var orig = parsePrice(prices.compare);
      var sale = parsePrice(prices.current);
      if (orig > sale && orig > 0) {
        var pct = Math.round((1 - sale / orig) * 100);
        if (pct > 0) badgeHTML = '<span class="tj-qty__badge">' + pct + '% OFF</span>';
      }
    }

    var priceHTML = '';
    if (prices.current) {
      priceHTML = '<span class="tj-qty__prices">';
      if (prices.compare) priceHTML += '<span class="tj-qty__compare">' + prices.compare + '</span>';
      priceHTML += '<span class="tj-qty__price">' + prices.current + '</span>';
      priceHTML += '</span>';
    }
    row.innerHTML = '<span class="tj-qty__name">' + label + badgeHTML + '</span>' + priceHTML;

    if (nativeWrap) {
      nativeWrap.parentNode.insertBefore(row, nativeWrap);
    }

    // Hide dynamic checkout buttons
    var dynamicBtns = productInfo.querySelector('.shopify-payment-button, .dynamic-checkout');
    if (dynamicBtns) dynamicBtns.style.display = 'none';

    // Move payment installments below the Add to Cart button
    var paymentTerms = productInfo.querySelector('shopify-payment-terms, payment-terms, .shopify-payment-terms');
    var submitBtn = productInfo.querySelector('.product-form__submit');
    if (paymentTerms && submitBtn) {
      var btnContainer = submitBtn.closest('.product-form__buttons') || submitBtn.parentNode;
      btnContainer.parentNode.insertBefore(paymentTerms, btnContainer.nextSibling);
    }
  }

  if (customElements.get('product-info')) {
    init();
  } else {
    customElements.whenDefined('product-info').then(function () {
      setTimeout(init, 80);
    });
  }
})();
